import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Breadcrumb,
  Checkbox,
  Col,
  Form,
  Input,
  Row,
  Select,
  Spin,
  Table,
  Tooltip,
} from "antd";
import { ErrorNotificationMsg } from "../../utils/Notifications";
import {
  getRequest,
  getRequest1,
  patchRequest,
  postRequest,
} from "../../axios";
import { authUserData } from "../../utils/Helper";
import { FilterFilled } from "@ant-design/icons";
import { ReactComponent as RupeesSign } from "../../image/RupeesSign.svg";
import ButtonField from "../../common/htmlComponents/ButtonField";
import FormItem from "antd/es/form/FormItem";

const ShowSummaryPriceComparatives = () => {
  const { t } = useTranslation();
  const { Option } = Select;
  const navigate = useNavigate();
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [reload, setReload] = useState(false);
  const [siteName, setSiteName] = useState([]);
  const [materialName, setMaterialName] = useState([]);
  const [enableInputs, setEnableInputs] = useState(false);
  const { id } = useParams();
  const { Search } = Input;
  const [totalCount, settotalCount] = useState(0);
  const [rfqHistory, setRFQHistory] = useState([]);
  const [categoryTree, setCategoryTree] = useState([]);
  const [siteDetails, setSiteDetails] = useState(null);
  const [initialRender, setInitialRender] = useState(true);
  const formRef = useRef();
  const [checkedVendors, setCheckedVendors] = useState({});
  const [totalAmount, setTotalAmount] = useState(null);
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [selectedVendorsPerCity, setSelectedVendorsPerCity] = useState({});
  const [isCompleted, setIsCompleted] = useState(false);
  const [state, setState] = useState({
    hide_r0_price: false,
    hide_r1_price: false,
    hide_r_price: false,
    site_id: [],
    material_type_id: [],
  });
  const [apiLoading, setapiloading] = useState(false);
  const [hideInitialBidPrice, sethideInitialBidPrice] = useState(false);
  const [hideR1BidPrice, setHideR1BidPrice] = useState(false);
  const [hideRBidPrice, setHideRBidPrice] = useState(false);
  const [showUnitRateCementR1, setShowUnitRateCementR1] = useState(false);
  const [showUnitRateCementR, setShowUnitRateCementR] = useState(false);
  const [isFinalBidPrice, setIsFinalBidPrice] = useState(false);
  const [showAdditionalCheckboxesFinal, setShowAdditionalCheckboxesFinal] =
    useState(true);
  const [showAdditionalCheckboxes, setShowAdditionalCheckboxes] =
    useState(false);
  const [comparativesRFQ, setComparativesRFQ] = useState([]);
  const [rfqNumber, setRfqNumber] = useState(null);
  const [reasons, setReasons] = useState([
    "Urgent Delivery",
    "Non Availibility of stock",
    "Exploring alternate Supplier",
    "Split of share",
    "Continue Business relation",
    "Assurance of supply",
    "Others",
  ]);
  const [selectedVendorsPerSite, setSelectedVendorsPerSite] = useState({});
  const [selectedVendorTotalAmount, setSelectedVendorTotalAmount] = useState(0);
  const [editTime, setEditTime] = useState(false);
  const [isOtherReason, setIsOtherReason] = useState(false);
  const [otherReasons, setOtherReasons] = useState({});

  useEffect(() => {
    const getVendorBidRFQ = async () => {
      setapiloading(true);
      try {
        const response = await getRequest(
          `comparative-rfq/${id}/summery-of-price-comparative/`
        );

        if (response.data.data) {
          setEditTime();
          const responseData =
            response?.data?.data?.summery_of_price_comparative;

          const floatId = response?.data?.data?.float_rfq;
          setIsOtherReason(response?.data?.data?.other_reason);

          const tableData =
            response?.data?.data?.purchase_order_city_details?.map(
              (item, index) => {
                let cityId = index;
                return {
                  key: index,
                  floatId: floatId,
                  company: CompanyId,
                  cityName: item.bid_rfq_city_name,
                  cityTotal: item.city_total,
                  comparative: item.purchase_order_site_details.map(
                    (com, ind) => {
                      return {
                        cityId,
                        siteId: com.rfq_site_id,
                        siteName: com.rfq_site_name,
                        siteSubTotal: 0,
                        siteLocations: com.bid_rfq_detail.map(
                          (item1, index) => {
                            return {
                              cityId,
                              cityName: item.bid_rfq_city_name,
                              materialName: item1.bid_material_type_name,
                              quantity: item1.bid_material_quantity,
                              uom: item1.bid_uom,
                              vendorBids: item1.vendor.map((item2, index3) => {
                                console.log("item2cxz", item2);
                                if (item2.selected_reason === "Others") {
                                  setOtherReasons((prev) => ({
                                    ...prev,
                                    [`${index3}_${cityId}`]:
                                      item2?.other_reason_text,
                                  }));
                                }

                                return {
                                  cityId,
                                  cityName: item.bid_rfq_city_name,
                                  bidRfqId: item2.bid_rfq_id,
                                  vendorName: item2.vendor_name,
                                  r_price: item2.unit_rate,
                                  total_amount_without_gst:
                                    item2.amount_without_gst,
                                  total_amount_with_gst: item2.amount_with_gst,
                                  vendorId: item2.id,
                                  siteTotal: 0,
                                  siteId: com.rfq_site_id,
                                  vendor_checked: item2?.is_selected
                                    ? item2?.is_selected
                                    : false,
                                  select_reason: item2?.selected_reason
                                    ? item2?.selected_reason
                                    : null,
                                  comparison_ranking: item2?.comparison_ranking,
                                  other_reason_text:
                                    item2?.other_reason_text || "",
                                };
                              }),
                            };
                          }
                        ),
                      };
                    }
                  ),
                };
              }
            );

          let initialTotal = 0;

          tableData.forEach((city) => {
            city.comparative.forEach((site) => {
              site.siteLocations.forEach((location) => {
                location.vendorBids.forEach((vendorBid) => {
                  if (vendorBid.vendor_checked) {
                    initialTotal += vendorBid.total_amount_with_gst;
                  }
                });
              });
            });
          });

          setSelectedVendorTotalAmount(initialTotal); // Set the initial total here

          // Initialize selectedVendorsPerSite
          const initialSelectedVendors = {};
          tableData.forEach((city, ind) => {
            city.comparative.forEach((site) => {
              site.siteLocations.forEach((location) => {
                location.vendorBids.forEach((vendorBid) => {
                  if (vendorBid.vendor_checked) {
                    initialSelectedVendors[ind] = vendorBid.vendorId;
                  }
                });
              });
            });
          });
          setSelectedVendorsPerCity(initialSelectedVendors);

          setComparativesRFQ(tableData);

          setRfqNumber(response.data?.data?.rfq_number);
          if (response?.data?.data?.po_approval === true) {
            setIsCompleted(response?.data?.data?.po_approval);
          }
          setapiloading(false);
        } else {
          ErrorNotificationMsg(t("Error in Comparatives"));
          setapiloading(false);
        }
      } catch (error) {
        console.error("Error:", error);
        setapiloading(false);
      }
    };
    getVendorBidRFQ();
  }, [id]);

  const handleCheckboxChange = () => {
    setIsFinalBidPrice(!isFinalBidPrice);
    setShowAdditionalCheckboxesFinal(true);

    setState((prevState) => ({
      ...prevState,
      is_final_bid_price: !isFinalBidPrice,
    }));
  };

  const handleCheckboxhideR1 = () => {
    sethideInitialBidPrice(!hideInitialBidPrice);
  };

  const handleCheckboxhideR = () => {
    setHideR1BidPrice(!hideR1BidPrice);
  };

  const handleCheckboxhideRR = () => {
    setHideRBidPrice(!hideRBidPrice);
  };

  const updateState = async () => {
    // try {
    //   const payload = {
    //     ...comparativesRFQ,
    //   }
    //   const response = await patchRequest(`comparative-rfq/${id}/get-comparative-details-by-site-wise/`, payload);
    //   console.log('response 100', response);
  // }
   
   
  };

  const handleLocalChange = (text, vendorId, cityId) => {
    setOtherReasons((prev) => ({
      ...prev,
      [`${vendorId}_${cityId}`]: text,
    }));
  };
  const handleOtherReasonChange = (value, vendorId, cityId) => {
    console.log("INPUT:", value);

    setComparativesRFQ((prev) =>
      prev.map((entry) => ({
        ...entry,
        comparative: entry.comparative.map((comp) => ({
          ...comp,
          siteLocations: comp.siteLocations.map((loc) => ({
            ...loc,
            vendorBids: loc.vendorBids.map((vendor) => {
              if (vendor.vendorId === vendorId && vendor.cityId === cityId) {
                return {
                  ...vendor,
                  other_reason_text: value, // update as user types
                };
              }
              return vendor;
            }),
          })),
        })),
      }))
    );
  };
  const handleBlurUpdate = (vendorId, cityId) => {
    const key = `${vendorId}_${cityId}`;
    handleOtherReasonChange(otherReasons[key], vendorId, cityId);
  };
  const handleSiteNameSelectChange = async (value) => {
    const updatedState1 = { ...state, site_id: value };
    setState(updatedState1);

  };
  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
    } else {
      updateState();
    }
  }, [state]);

  const handleMaterialSelectChange = async (value) => {
    const updatedState2 = { ...state, material_type_id: value };
    setState(updatedState2);
  };

  const handleUnitRateOfCementChangeR0 = (
    value,
    recordKey,
    siteIndex,
    gstRate,
    quantity
  ) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids.r_price = value;
    site.vendorBids.r_price = ((value * (100 + gstRate)) / 100) * quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };

  const handleUnitRateOfFreightChangeR0 = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids.r_price = value;
    site.vendorBids.r_price = value * site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };

  const handleTotalUnitRateR0Change = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids.r_price = value;
    site.vendorBids.r_price = value / site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };
  const [enableInputsR1, setEnableInputsR1] = useState(false);

  const handleUnitRateOfCementChangeR1 = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids.r_price = value;
    site.vendorBids.r_price = value * site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };

  const calculateTotalUnitRateOfCementR1 = (record) => {
    const totalUnitRateOfCementR1 = record.siteLocations.reduce(
      (total, site) => total + (parseFloat(site.vendorBids.r_price) || 0),
      0
    );
    return totalUnitRateOfCementR1.toFixed(0);
  };

  const handleUnitRateOfFreightChangeR1 = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids.r_price = value;
    site.vendorBids.r_price = value * site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };

  const handleTotalUnitRateOfCementR1Change = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids.r_price = value;
    site.vendorBids.r_price = value / site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };
  const renderUnitRateOfCementR0 = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => (
            <Input
              key={site.name + siteIndex}
              disabled={enableInputs}
              style={{ marginRight: "10px", width: "300px" }}
              // placeholder={`Enter Unit Rate of Cement for ${site.name}`}
              value={site.vendorBids[0].r_price}
              onChange={(e) =>
                handleUnitRateOfCementChangeR0(
                  e.target.value,
                  record.key,
                  siteIndex,
                  site.vendorBids[0].gst_rate,
                  site.quantity
                )
              }
              type="number"
            />
          ))}
        </div>
      </>
    );
  };

  const vendors = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", gap: "10px" }}>
          {record.siteLocations.map((site, siteIndex) => (
            <div key={siteIndex}>
              {site.vendorBids.map((vendor, vendorIndex) => (
                <>
                  <Input
                    key={vendorIndex}
                    disabled={enableInputs}
                    style={{ marginRight: "10px", width: "150px" }}
                    value={vendor.r_price[0].r_unit_price}
                    onChange={(e) =>
                      handleUnitRateOfCementChangeR0(
                        e.target.value,
                        record.key,
                        siteIndex,
                        vendor.gst_rate,
                        site.quantity
                      )
                    }
                    type="number"
                  />
                </>
              ))}
            </div>
          ))}
        </div>
      </>
    );
  };

  const calculateTotalUnitRateOfCementR0 = (record) => {
    const totalUnitRateOfCement = record.siteLocations.reduce(
      (total, site) => total + (parseFloat(site.vendorBids[0].r_price) || 0),
      0
    );
    return totalUnitRateOfCement.toFixed(0);
  };

  const renderUnitRateOfFreightR0 = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => (
            <Input
              key={site.name + siteIndex}
              disabled={enableInputs}
              style={{ marginRight: "10px", width: "300px" }}
              placeholder={`Enter Unit Rate of Freight for ${site.name}`}
              value={site.vendorBids[0].r_price[0].r_unit_price}
              onChange={(e) =>
                handleUnitRateOfFreightChangeR0(
                  e.target.value,
                  record.key,
                  siteIndex
                )
              }
              type="number"
            />
          ))}
        </div>

        <Input
          placeholder={`Total Unit Rate of Freight R0`}
          prefix={<RupeesSign />}
          value={calculateTotalUnitRateOfFreightR0(record)} // Assuming unit_rate_of_cement is a property in the record
          style={{ width: "300px", top: "10px" }} // Adjust width as needed
          disabled
        />
      </>
    );
  };

  const calculateTotalUnitRateOfFreightR0 = (record) => {
    const totalUnitRateOfFreightR0 = record.siteLocations.reduce(
      (total, site) => total + (parseFloat(site.vendorBids[0].r_price) || 0),
      0
    );
    return totalUnitRateOfFreightR0.toFixed(0);
  };


  const calculateTotalUnitRateOfR0 = (record) => {
    const totalUnitRateOfCementR0 =
      parseFloat(calculateTotalUnitRateOfCementR0(record)) || 0;
    const totalUnitRateOfFreightR0 =
      parseFloat(calculateTotalUnitRateOfFreightR0(record)) || 0;

    return (totalUnitRateOfCementR0 + totalUnitRateOfFreightR0).toFixed(0);
  };

  const renderUnitRateOfCementR1 = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => (
            <Input
              key={site.name + siteIndex}
              prefix={<RupeesSign />}
              disabled={enableInputsR1}
              style={{ marginRight: "10px", width: "300px" }}
              placeholder={`Enter Unit Rate of Cement for ${site.name}`}
              value={site.vendorBids[0].r_price}
              onChange={(e) =>
                handleUnitRateOfCementChangeR1(
                  e.target.value,
                  record.key,
                  siteIndex
                )
              }
              type="number"
            />
          ))}
        </div>

        <div style={{ display: "flex", flexDirection: "column" }}>
          <Input
            placeholder={`Total Unit Rate of Cement R1`}
            prefix={<RupeesSign />}
            value={calculateTotalUnitRateOfCementR1(record)} // Assuming unit_rate_of_cement is a property in the record
            style={{ width: "300px", top: "10px" }} // Adjust width as needed
            disabled
          />
        </div>
      </>
    );
  };

  const renderUnitRateOfFreightR1 = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => (
            <Input
              key={site.name + siteIndex}
              prefix={<RupeesSign />}
              disabled={enableInputsR1}
              style={{ marginRight: "10px", width: "300px" }}
              placeholder={`Enter Unit Rate of Freight for ${site.name}`}
              value={site.vendorBids[0].r_price}
              onChange={(e) =>
                handleUnitRateOfFreightChangeR1(
                  e.target.value,
                  record.key,
                  siteIndex
                )
              }
              type="number"
            />
          ))}
        </div>

        <Input
          placeholder={`Total Unit Rate of Freight R1`}
          prefix={<RupeesSign />}
          value={calculateTotalUnitRateOfFreightR1(record)} 
          style={{ width: "300px", top: "10px" }} 
          disabled
        />
      </>
    );
  };

  const calculateTotalUnitRateOfFreightR1 = (record) => {
    const totalUnitRateOfFreightR1 = record.siteLocations.reduce(
      (total, site) => total + (parseFloat(site.vendorBids[0].r_price) || 0),
      0
    );
    return totalUnitRateOfFreightR1.toFixed(0);
  };

  const renderUnitRateOfTotalUnitRateR1 = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => (
            <Input
              key={site.name + siteIndex}
              prefix={<RupeesSign />}
              disabled={enableInputsR1}
              style={{ marginRight: "10px", width: "300px" }}
              placeholder={`Enter Total Unit Rate for ${site.name}`}
              value={site.vendorBids[0].r_price}
              onChange={(e) =>
                handleTotalUnitRateOfCementR1Change(
                  e.target.value,
                  record.key,
                  siteIndex
                )
              }
              type="number"
            />
          ))}
        </div>

        <Input
          placeholder={`Total Unit Rate of R1`}
          prefix={<RupeesSign />}
          value={calculateTotalUnitRateOfR1(record)} 
          style={{ width: "300px", top: "10px" }} 
          disabled
        />
      </>
    );
  };

  const calculateTotalUnitRateOfR1 = (record) => {
    const totalUnitRateOfCementR1 =
      parseFloat(calculateTotalUnitRateOfCementR1(record)) || 0;
    const totalUnitRateOfFreightR1 =
      parseFloat(calculateTotalUnitRateOfFreightR1(record)) || 0;

    return (totalUnitRateOfCementR1 + totalUnitRateOfFreightR1).toFixed(0);
  };


  const handleLowestChange = (totalAmount, vendorId, isChecked, cityId, vendorID) => {

    if (isChecked) {
      setSelectedVendorsPerCity((prev) => ({
        ...prev,
        // [cityId]: vendorId,
        [cityId]: vendorId,

      }));
      setSelectedVendorTotalAmount((prevTotal) => prevTotal + totalAmount);
      
      const cityTotal = comparativesRFQ
        .find((c) => c.cityName === vendorID)
        ?.cityTotal.find((v) => v.vendor_id === vendorId);
    } else {

      setSelectedVendorsPerCity((prev) => ({
        ...prev,
        [cityId]: undefined,
      }));

      setSelectedVendorTotalAmount((prevTotal) => prevTotal - totalAmount);
    }
    // Update comparativeRFQ state
    setComparativesRFQ((prev) =>
      prev.map((city) => {
        if (city.key === cityId) {
          return {
            ...city,
            comparative: city.comparative.map((site) => ({
              ...site,
              siteLocations: site.siteLocations.map((location) => ({
                ...location,
                vendorBids: location.vendorBids.map((vendor) => ({
                  ...vendor,
                  vendor_checked: vendor.vendorId === vendorId && isChecked,
                  disabled: isChecked ? vendor.vendorId !== vendorId : false,
                  select_reason: isChecked ? vendor.select_reason : null,
                })),
              })),
            })),
          };
        }

        return city;
      })
    );
  };

  const handleReasonChange = (value, vendorId, cityId) => {
    setComparativesRFQ((prev) =>
      prev.map((city) => {
        if (city.key === cityId) {
          return {
            ...city,
            comparative: city.comparative.map((site) => ({
              ...site,
              siteLocations: site.siteLocations.map((location) => ({
                ...location,
                vendorBids: location.vendorBids.map((vendor) => ({
                  ...vendor,
                  select_reason: vendor.vendorId === vendorId ? value : null,
                })),
              })),
            })),
          };
        }
        return city;
      })
    );
  };
  const vendorNames = [
    ...new Set(
      comparativesRFQ.flatMap((item) =>
        item.comparative.flatMap((comp) =>
          comp.siteLocations.flatMap((location) =>
            location.vendorBids.map((vendor) => vendor.vendorName)
          )
        )
      )
    ),
  ];

  const vendorColumns = vendorNames.flatMap((vendorName, index) => ({
    title: vendorName,
    width: 150,
    className: "thirdth",
    children: [
      {
        title: `Unit Rate`,
        dataIndex: "vendors",
        width: 70,
        align: "right",
        render: (vendors, row) => {
          if (Array.isArray(vendors)) {
            const vendor = vendors.find((v) => v.vendorName === vendorName);
            if (!vendor) return null;

            const vendorId = vendor.vendorId;
            const siteId = vendor.siteId;
            const cityId = vendor.cityId;
            const totalAmount = vendor.totalAmount ?? 0;
            console.log('vendorcc', vendor, 'row', row);
            
            if (row.siteName === "Ranking" &&
              row.vendors?.find(
                (v) => v.vendorId === vendor.vendorId
              )) {
                console.log("ffffffffffffff");
                
              const vendorTotals = row.vendors.map((v) => v.totalAmount ?? 0);
              const minTotal = Math.min(...vendorTotals);
              const maxTotal = Math.max(...vendorTotals);

              const secondMinTotal = Math.min(
                ...vendorTotals.filter((total) => total > minTotal)
              );

              const thirdMinTotal = Math.min(
                ...vendorTotals.filter((total) => total > secondMinTotal)
              );

              let yyy = vendor?.totalAmountWithGST;
              const cityId = row.ind; // You'll need to make sure this is available in your row data
              const selectedVendorForCity = selectedVendorsPerCity[cityId];
              const isChecked = vendor.vendorId === selectedVendorForCity;
              const isDisabled = selectedVendorForCity && !isChecked;

              const cityName = row?.cityName;

              const cityName1 = vendor.cityName;

              const cellContent = (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    gap: "8px",
                    paddingRight: "8px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      justifyContent: "flex-end",
                    }}
                  >
                    {totalAmount === minTotal && (
                      <Tooltip
                        color={"#094E8F"}
                        placement="left"
                        title={
                          <span style={{ color: "#fff" }}>Lowest Price</span>
                        }
                      >
                        <span className="lowest2">L1</span>
                      </Tooltip>
                    )}
                    {totalAmount === secondMinTotal && (
                      <Tooltip
                        color={"#094E8F"}
                        placement="left"
                        title={
                          <span style={{ color: "#fff" }}>
                            Second Lowest Price
                          </span>
                        }
                      >
                        <span className="secondLowest2">L2</span>
                      </Tooltip>
                    )}
                    {totalAmount === thirdMinTotal && (
                      <Tooltip
                        color={"#094E8F"}
                        placement="left"
                        title={
                          <span style={{ color: "#fff" }}>
                            Third Lowest Price
                          </span>
                        }
                      >
                        <span className="thirdLowest2">L3</span>
                      </Tooltip>
                    )}
                    <Checkbox
                      checked={vendor?.vendorChecked}
                      // disabled={isCompleted === true ? true : isDisabled}
                      onChange={(e) => {
                         return
                        handleLowestChange(
                          vendor.totalAmountWithGST,
                          vendor.vendorId,
                          e.target.checked,
                          cityId,
                          vendor.vendorName,
                          cityName1
                        );
                      }}
                    />
                  </div>
                  {vendor.totalAmount !== minTotal && (
                    <Select
                      style={{ width: "200px" }}
                      showArrow
                      placeholder={"Select Reason"}
                      disabled={true}
                      value={vendor?.selectedReason}
                      suffixIcon={null}
                    >
                      {reasons.map((item, index) => (
                        <Option key={index} value={item}>
                          {item}
                        </Option>
                      ))}
                    </Select>
                  )}
                  {vendor?.selectedReason === "Others" && isOtherReason && (
                    <Input
                      style={{ marginTop: 8, width: 200 }}
                      maxLength={30}
                      placeholder="Enter custom reason"
                      value={
                        otherReasons[`${vendor.vendorId}_${vendor.cityId}`] ??
                        vendor.other_reason_text ??
                        ""
                      }
                      disabled
                      onChange={(e) =>
                        handleLocalChange(
                          e.target.value,
                          vendor.vendorId,
                          vendor.cityId
                        )
                      }
                      onBlur={() =>
                        handleBlurUpdate(vendor.vendorId, vendor.cityId)
                      }
                    />
                  )}
                  {vendor.totalAmount === minTotal && (
                    <Select
                      style={{ width: "200px", visibility: "hidden" }}
                      showArrow
                      placeholder={"Select Reason"}
                      disabled={
                        isCompleted === true
                          ? true
                          : !isChecked && !vendor?.selectedReason
                      }
                      value={vendor?.selectedReason}
                      onChange={(value) =>
                        handleReasonChange(value, vendor.vendorId, cityId)
                      }
                    >
                      {reasons.map((item, index) => (
                        <Option key={index} value={item}>
                          {item}
                        </Option>
                      ))}
                    </Select>
                  )}
                </div>
              );
              return {
                children: cellContent,
                props: {
                  colSpan: 3,
                },
              };
            } else if (vendor.unitRate !== null && row.siteName !== "Ranking") {
              return (
                <>
                  <RupeesSign style={{ height: "10px", marginTop: "3px" }} />{" "}
                  {vendor.unitRate.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  })}
                </>
              );
            }
          }
          return null;
        },
      },
      {
        // title: `Total Amount Without GST`,
        title: (
          <>
            <span>Total Amount</span>
            <br />
            <span>Without GST</span>
          </>
        ),

        dataIndex: "vendors",
        width: 100,
        align: "right",
        render: (vendors, row) => {
          const vendor = vendors.find((v) => v.vendorName === vendorName);
            if (!vendor) return null;
          if (row.siteName === "Ranking" &&
            row.vendors?.find(
              (v) => v.vendorId === vendor.vendorId
            )) {
            console.log('ffvendorsff', vendors, 'row', row);
            
            return { props: { colSpan: 0 } };
          }
          if (Array.isArray(vendors)) {
            const vendor = vendors.find((v) => v.vendorName === vendorName);
            let className = "normal-field";
            if (row.siteName === "Sub-Total") {
              className = "subtotall";
            } else if (row.siteName === "City-sub-Total") {
              className = "citytotall";
            }
            return vendor ? (
              <div className={className}>
                ₹{" "}
                {vendor.totalAmount.toLocaleString("en-IN", {
                  maximumFractionDigits: 0,
                }) ?? 0}
              </div>
            ) : null;
          }
          return null;
        },
      },
      {
        // title: `Total Amount With GST`,
        title: (
          <>
            <span>Total Amount</span>
            <br />
            <span>With GST</span>
          </>
        ),
        dataIndex: "vendors",
        width: 80,
        align: "right",
        render: (vendors, row) => {
          const vendor = vendors.find((v) => v.vendorName === vendorName);
            if (!vendor) return null;
          if (row.siteName === "Ranking" &&
            row.vendors?.find(
              (v) => v.vendorId === vendor.vendorId
            )) {
            return { props: { colSpan: 0 } };
          }
          if (Array.isArray(vendors)) {
            const vendor = vendors.find((v) => v.vendorName === vendorName);
            let className = "normal-field";
            if (row.siteName === "Sub-Total") {
              className = "subtotall";
            } else if (row.siteName === "City-sub-Total") {
              className = "citytotall";
            }
            return vendor ? (
              <div className={className}>
                ₹{" "}
                {vendor.totalAmountWithGST.toLocaleString("en-IN", {
                  maximumFractionDigits: 0,
                }) ?? 0}
              </div>
            ) : null;
          }
          return null;
        },
      },
    ],
  }));

  [...vendorNames].map((vendorName, index) => {});

  const columns = [
    {
      title: "Sr.",
      dataIndex: "sr",
      width: 30,
    },
    {
      title: "City",
      dataIndex: "city",
      width: 80,
    },
    {
      title: "Site",
      dataIndex: "siteName",
      width: 80,
      render: (text, record) => {
        console.log("recorddddddd", record);

        if (record?.siteName === "Sub-Total") {
          return <div className="subtotal">{"Sub total"}</div>;
        } else if (record?.siteName === "City-sub-Total") {
          return <div className="citytotal">{"City total"}</div>;
        } else {
          return <>{record.siteName}</>;
        }
      },
    },
    {
      title: "Items",
      dataIndex: "item",
      width: 80,
    },
    {
      title: "Qty.",
      dataIndex: "qty",
      width: 80,
      align: "center",
    },
    {
      title: "UoM.",
      dataIndex: "UOM",
      width: 80,
      align: "center",
    },
    ...vendorColumns,
  ];

  let cityTotal = 0;
  let accumulatedCitySubTotalVendors = {};

  const data = comparativesRFQ.flatMap((item, index) => {
    const citySubTotal = item.cityTotal[0]?.citySubTotal || 0;
    cityTotal += citySubTotal;

    const siteData = item.comparative.flatMap((comparative, compIndex) => {
      let comparativeSubTotal = 0;
      const vendorsSubTotal = {};
      const vendorsSubTotalWithGST = {};
      let venID = {};

      const locationData = comparative.siteLocations.map(
        (location, locationIndex) => {
          const vendors = location.vendorBids.map((vendor) => {
            const unitRate = vendor.r_price || 0;
            const totalAmount = vendor.total_amount_without_gst || 0;
            const totalAmountWithGST = vendor.total_amount_with_gst || 0;

            if (!vendorsSubTotal[vendor.vendorName]) {
              vendorsSubTotal[vendor.vendorName] = 0;
            }
            vendorsSubTotal[vendor.vendorName] += totalAmount;

            if (!vendorsSubTotalWithGST[vendor.vendorName]) {
              vendorsSubTotalWithGST[vendor.vendorName] = 0;
            }
            vendorsSubTotalWithGST[vendor.vendorName] += totalAmountWithGST;

            venID[vendor.vendorName] = vendor.vendorId;

            return {
              siteId: comparative.siteId,
              vendorId: vendor.vendorId,
              vendorName: vendor.vendorName,
              unitRate: vendor.r_price,
              totalAmount: vendor.total_amount_without_gst,
              totalAmountWithGST: vendor.total_amount_with_gst,
              siteIndex: vendor.siteId,
              other_reason_text: vendor.other_reason_text,
            };
          });

          vendors.forEach((vendor) => {
            comparativeSubTotal += vendor.totalAmount;
          });

          return {
            key: `${index}-${compIndex}-${locationIndex}`,
            sr:
              locationIndex === 0 && compIndex === 0 ? <>{index + 1}</> : null,
            city:
              locationIndex === 0 && compIndex === 0 ? (
                <>{item.cityName}</>
              ) : null,
            siteName: locationIndex === 0 ? <>{comparative.siteName}</> : null,
            item: <>{location.materialName}</>,
            qty: <>{location.quantity}</>,
            UOM: (
              <>{location.uom === "Cubic Meter" ? "Cu. Mtr." : location.uom}</>
            ),
            vendors: vendors,
            siteIndex: locationIndex,
            cityName: item.cityName,
          };
        }
      );

      // Add subtotal for each site only if there are vendors
      const vendorSubTotals = Object.keys(vendorsSubTotal)
        .map((vendorName) => {
          const totalAmount = vendorsSubTotal[vendorName];
          const totalAmountWithGST = vendorsSubTotalWithGST[vendorName];

          // Only include vendor if total amount is greater than 0
          if (totalAmount > 0) {
            return {
              vendorId: venID[vendorName],
              vendorName,
              unitRate: null,
              siteId: comparative.siteId,
              totalAmount,
              totalAmountWithGST,
            };
          }
          return null; // Return null for vendors with zero total
        })
        .filter(Boolean); // Filter out null values

      if (vendorSubTotals.length > 0) {
        locationData.push({
          key: `${index}-${compIndex}-SubTotal`,
          siteName: "Sub-Total",
          compIndex: compIndex,
          ind: index,
          item: null,
          qty: null,
          UOM: null,
          vendors: vendorSubTotals,
        });
      }

      return locationData;
    });

    // Calculate city total only if there are vendors available
    const citySubTotalVendors = vendorNames
      .map((vendorName) => {
        const totalAmount = siteData.reduce((total, row) => {
          if (row.vendors) {
            const vendor = row?.vendors?.find(
              (v) => v.vendorName === vendorName
            );
            if (vendor?.unitRate !== null) {
              return total + (vendor ? vendor.totalAmount : 0);
            }
          }
          return total;
        }, 0);

        const totalAmountWithGST = siteData.reduce((total, row) => {
          if (row.vendors) {
            const vendor = row?.vendors?.find(
              (v) => v.vendorName === vendorName
            );
            if (vendor?.unitRate !== null) {
              return total + (vendor ? vendor.totalAmountWithGST : 0);
            }
          }
          return total;
        }, 0);

        // Only include city total if totalAmount is greater than 0
        if (totalAmount > 0) {
          if (!accumulatedCitySubTotalVendors[vendorName]) {
            accumulatedCitySubTotalVendors[vendorName] = 0;
          }
          accumulatedCitySubTotalVendors[vendorName] += totalAmount;

          return {
            vendorName,
            unitRate: null,
            totalAmount,
            totalAmountWithGST,
          };
        }
        return null; // Return null for vendors with zero total
      })
      .filter(Boolean); // Filter out null values

    // Add city subtotal only if there are valid vendors
    if (citySubTotalVendors.length > 0) {
      siteData.push({
        key: `${index}-CitySubTotal`,
        siteName: "City-sub-Total",
        item: null,
        qty: null,
        UOM: null,
        vendors: citySubTotalVendors,
      });
    }

    const RankingData = item.comparative.flatMap((comparative, compIndex) => {
      const locationData = [];
      let cityName = null;
      let cityId = null;
      let selectedReason = null;
      let vendorChecked = null;
      if (compIndex === 0) {
        const cityVendors = {};
        item.comparative.forEach((site) => {
          site.siteLocations.forEach((location) => {
            location.vendorBids.forEach((vendor) => {
              console.log("vendorfd66", vendor);

              cityName = vendor?.cityName;
              cityId = vendor?.cityId;
              selectedReason = vendor?.select_reason;
              vendorChecked = vendor?.vendor_checked;
              const vendorName = vendor.vendorName;
              const totalAmount = vendor.total_amount_without_gst || 0;
              const totalAmountWithGST = vendor.total_amount_with_gst || 0;

              if (!cityVendors[vendorName]) {
                cityVendors[vendorName] = {
                  totalAmount: 0,
                  totalAmountWithGST: 0,
                  vendorId: vendor.vendorId,
                  selectedReason: vendor.select_reason,
                  vendorChecked: vendor.vendor_checked,
                  other_reason_text: vendor.other_reason_text,
                  cityId: vendor.cityId,
                };
              }

              cityVendors[vendorName].totalAmount += totalAmount;
              cityVendors[vendorName].totalAmountWithGST += totalAmountWithGST;
            });
          });
        });

        // const sortedVendors = Object.entries(cityVendors).sort(
        //   (a, b) => a[1].totalAmount - b[1].totalAmount
        // );
console.log('cityVdendors', cityVendors);

        const sortedVendors = Object.entries(cityVendors)
          .filter(([_, data]) => data.cityId === cityId )
          .sort((a, b) => a[1].totalAmount - b[1].totalAmount);
          console.log('cityVendorscx', sortedVendors);

        siteData.push({
          key: `${index}-Ranking`,
          siteName: "Ranking",
          ind: index,
          item: null,
          qty: null,
          UOM: null,
          vendors: sortedVendors.map(([vendorName, data], rankIndex) => {
            return {
              cityName,
              cityId,
              vendorName,
              vendorId: data.vendorId,
              totalAmount: data.totalAmount,
              totalAmountWithGST: data.totalAmountWithGST,
              selectedReason: data?.selectedReason,
              vendorChecked: data?.vendorChecked,
              rank: `L${rankIndex + 1}`,
              other_reason_text: data?.other_reason_text,
            };
          }),
        });
      }

      return comparative.siteLocations.map((location, locationIndex) => ({
        key: `${index}-${compIndex}-${locationIndex}`,
        sr: locationIndex === 0 && compIndex === 0 ? <>{index + 1}</> : null,
        city:
          locationIndex === 0 && compIndex === 0 ? <>{item.cityName}</> : null,
        siteName: locationIndex === 0 ? <>{comparative.siteName}</> : null,
        item: <>{location.materialName}</>,
        qty: <>{location.quantity}</>,
        UOM: <>{location.uom}</>,
        vendors: location.vendorBids.map((vendor) => ({
          siteId: comparative.siteId,
          vendorId: vendor.vendorId,
          vendorName: vendor.vendorName,
          unitRate: vendor.r_price,
          totalAmount: vendor.total_amount_without_gst,
          totalAmountWithGST: vendor.total_amount_with_gst,
          cityName: <>{item.cityName}</>,
        })),
      }));
    });

    return siteData;
  });



  const handleOnSubmit = async () => {
    if (comparativesRFQ.length === 0) {
      ErrorNotificationMsg("Please select at least one city");
      return;
    }

    const payload = {
      float_rfq: comparativesRFQ[0]?.floatId,
      company: comparativesRFQ[0]?.company,
      purchase_order_city_details: [],
    };

    let citiesWithVendors = [];
    console.log('comparativesRFQ', comparativesRFQ);
    

    comparativesRFQ.forEach((cityItem) => {
      const vendorsMap = {};

      cityItem.comparative.forEach((siteItem) => {
        siteItem.siteLocations.forEach((siteLocation) => {
          siteLocation.vendorBids.forEach((vendorBid) => {
            if (vendorBid.vendor_checked) {
              const vendorId = vendorBid.vendorId;
              const siteId = siteItem.siteId;

              if (!vendorsMap[vendorId]) {
                vendorsMap[vendorId] = {
                  vendor: vendorId,
                  comparison_ranking: vendorBid.comparison_ranking,
                  select_reason: vendorBid.select_reason,
                  sitesMap: {},
                };
              }

              const vendorEntry = vendorsMap[vendorId];

              if (!vendorEntry.sitesMap[siteId]) {
                vendorEntry.sitesMap[siteId] = {
                  rfq_site_name: siteId,
                  amount_without_gst: 0,
                  amount_with_gst: 0,
                  bid_rfq_detail: [],
                };
              }

              const siteEntry = vendorEntry.sitesMap[siteId];
              siteEntry.amount_without_gst +=
                vendorBid.total_amount_without_gst;
              siteEntry.amount_with_gst += vendorBid.total_amount_with_gst;
              siteEntry.bid_rfq_detail.push(vendorBid.bidRfqId);
            }
          });
        });
      });

      const cityVendorEntries = Object.values(vendorsMap).map(
        (vendorEntry) => {
        return {
          vendor: vendorEntry.vendor,
          comparison_ranking: vendorEntry.comparison_ranking,
          select_reason: vendorEntry.select_reason,
          purchase_order_site_details: Object.values(vendorEntry.sitesMap),
        }}
      );

      if (cityVendorEntries.length > 0) {
        payload.purchase_order_city_details.push(...cityVendorEntries);
        citiesWithVendors.push(cityItem.id);
      }
    });

    if (payload.purchase_order_city_details.length === 0) {
      ErrorNotificationMsg("Please select vendor");
      return;
    }

    if (comparativesRFQ.length > citiesWithVendors.length) {
      ErrorNotificationMsg("Please select a vendor for each city");
      return;
    }

    for (const city of payload.purchase_order_city_details) {
      console.log('citycxz', city);
      
      if (!city.select_reason && city.comparison_ranking !== "L1" ) {
        ErrorNotificationMsg(
          "Please select a reason"
        );
        return;
      }
    }
    try {
      setBtnLoading(true);
      const response = await postRequest("po-order/", payload);
      if (response.data.success) {
        navigate(`/request-for-quotation/previewandsendapproval/${id}`);
        setBtnLoading(false);
      }
    } catch (error) {
      setBtnLoading(false);
      // Handle error
    }
  };

  const handleOnSubmitView = async () => {
    try {
      setBtnLoading(true);
      // const response = await postRequest("po-order/", payload);
      // if (response.data.success) {
        navigate(`/request-for-quotation/previewandsendapproval/${id}`);
        setBtnLoading(false);
      // }
    } catch (error) {
      setBtnLoading(false);
      // Handle error
    }
  };

  return (
    <>

      <section className="grid-sec mt-5">
        <div className="PR-body">
        <h5 className="rfq-number new">
              <span>Summary Price Comparative Statement</span>
            </h5>

          <Spin spinning={apiLoading}>
            <Table
              dataSource={data}
              className="comparativecustomtbl"
              bordered
              scroll={{
                x: "auto",
              }}
              pagination={false}
              columns={columns}
            />
            <div className="TotalAMT">
              <label>Proposed Order Value: </label>
              <div
                className="citytotal"
                style={{ width: "140px", textAlign: "end" }}
              >
                ₹{" "}
                {selectedVendorTotalAmount
                  ? selectedVendorTotalAmount.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })
                  : 0}
              </div>
            </div>
          </Spin>

        </div>
      </section>
    </>
  );
};

export default ShowSummaryPriceComparatives;
